/** @format */
import angular from 'angular';
import { ModalService } from 'sis-common';
import { decimalNumberFilterModule } from '../number/decimalNumber.filter';
import { CustomStudyDraftInfoModalComponent } from './customStudyDraftInfoModal.component';
import customStudyDraftInfoModalTpl from './customStudyDraftInfoModal.tpl.html';

customStudyDraftInfoModalService.$inject = ['modalService'];

export const customStudyDraftInfoModalModule = 'sis-components.customStudyDraftInfoModal';

angular
    .module(customStudyDraftInfoModalModule, [decimalNumberFilterModule, ModalService.downgrade.moduleName])
    .component('customStudyDraftInfoModal', {
        bindings: {
            close: '&',
            resolve: '<',
        },
        template: customStudyDraftInfoModalTpl,
    })
    .factory('customStudyDraftInfoModalService', customStudyDraftInfoModalService);

function customStudyDraftInfoModalService(modalService) {
    return {
        open: customStudyDraft =>
            modalService.open(CustomStudyDraftInfoModalComponent, { customStudyDraft }, { closeWithOutsideClick: true, size: 'sm' }).result,
    };
}
